<template>
  <!-- <OAuth v-if="linkMicrosoftAccount" @microsoftLogin="handleOAuth" /> -->
  <!-- <PostLoginHeader></PostLoginHeader> -->
  <main class="d-flex flex-wrap h-100 w-100 m-0 no-max-width">
    <div class="split-left  hero-container col-6 tab-hidden d-flex">
      <div class="text-top p-5">
        <h2 class="fs-2 fw-bold">California Criminal Sentencing Software</h2>
        <p class="fs-4">Calculate incarceration and determine collateral consequences in seconds</p>
      </div>
      <div class="blue-circle">
        <img id="hero-img" src="/crimetimeloginimage3.png" alt="CrimeTimeSimpleView">
      </div>

      <div class="text-bottom">
        <p style="color: white;" class="fs-4 mb-1 mt-3">Helping law professionals for over 25 years! </p>
        <p style="color: white;"> Already have an account?
          <router-link to="/login" style="color: white !important; text-decoration: underline;">
            Log in <i class="fa fa-arrow-right" style="color: white !important;"></i>
          </router-link>
        </p> <!-- <p class="small-text">Your trusted partner in crime data.</p> -->
      </div>
    </div>
    <div class="col-12 col-lg-6 d-flex flex-column align-items-center justify-content-center" v-if="!verificationSMSModal">
      <div class="w-100 w-lg-75 border-radius-1 border">

        <div class="modal-header d-flex align-items-center">
          <template v-if="enterpriseSignupQuestionModal">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="ms-3">
                <button @click="enterpriseSignupQuestionModal = !enterpriseSignupQuestionModal" class="btn btn-link text-dark p-0">
                  <i class="fa fa-arrow-left fa-lg"></i>
                </button>
              </div>

              <div class="fw-bold fs-3 m-auto">
                Create your account
              </div>

              <div class="me-3" style="min-width: 24px;">
              </div>
            </div>
          </template>

          <template v-else>
            <div class="d-flex justify-content-center w-100 fw-bold fs-3">
              Create your account
            </div>
          </template>
        </div>
        <div v-if="!enterpriseSignupQuestionModal" class="card-body mt-5 ml-5 mr-5 pr-5 pl-5">
          <div @submit.prevent="order" class="mb-2">
            <div class="d-flex flex-wrap g-3 w-100">
              <div class="col-12 col-lg-6 pl-0 pr-0 pr-lg-4 mb-3">
                <label class="fs-5 mb-1">First Name</label>
                <input v-model="firstName" type="text" name="FirstName" class="form-control form-control-lg fs-5 w-100" placeholder="First Name" />
                <small v-if="formIncomplete && !firstName?.length" class="form-text err">*First Name is required</small>
              </div>

              <div class="col-12 col-lg-6 p-0 mb-3">
                <label class="fs-5 mb-1">Last Name</label>
                <input v-model="lastName" type="text" name="LastName" class="form-control form-control-lg fs-5 w-100" placeholder="Last Name" />
                <small v-if="formIncomplete && !lastName?.length" class="form-text err">*Last Name is required</small>
              </div>
            </div>

            <div class="form-group mb-3">
              <label class="fs-5 mb-1">Email Address</label>
              <input v-model="username" type="email" name="Email" class="form-control form-control-lg fs-5 w-100 " placeholder="email@website.com" @blur="checkEmailFormat" />
              <small v-if="formIncomplete && !username?.length" class="form-text err">*Email Address is required</small>
              <small v-if="!emailFormat" class="form-text err">*Invalid Email</small>
              <small v-if="emailTaken" class="form-text err">*Email Already Taken</small>
            </div>
            <div class="form-group mb-3">
              <label class="fs-5 mb-1">Password</label>
              <div class="password-input-wrapper">
                <input :type="isPasswordVisible ? 'text' : 'password'" v-model="password" name="Password" class="form-control form-control-lg fs-5 w-100 pr-5" placeholder="Password" />
                <i :class="isPasswordVisible ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" class="password-toggle-icon" @click="togglePasswordVisibility"></i>
              </div>
              <small v-if="formIncomplete && !password?.length" class="form-text err">*Password is required</small>
              <small v-if="weakPassword" class="form-text err">*Password must be between 8 and 20 characters and contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character</small>
            </div>

            <!-- <div class="form-group col-6 pl-0 pr-0 mb-3"> -->

            <!-- <label class="fs-5 mb-1">Confirm Password</label>
                <input v-model="passwordConfirm" type="password" name="PasswordConfirm" class="form-control form-control-lg fs-5 w-100 " placeholder="Confirm password" />
                <small v-if="formIncomplete && !passwordConfirm?.length" style="color: red;" class="form-text  err fs-6">*Confirm Password is required</small>
                <small v-if="!passwordMatch" style="color: red;" class="err fs-5">*Passwords do not match</small> -->
            <!-- </div> -->
            <div v-if="currentType == 'enterprise'" class="form-group mb-3">
              <div class="mb-3" :class="currentType == 'enterprise' ? 'col-12 px-0' : 'col-6'">
                <label class="fs-5 mb-1">Cell Phone Number</label>
                <!-- {{ phoneFormat }} -->
                <input v-model="phone" type="phone" name="Phone" class="form-control form-control-lg fs-5 w-100 " placeholder="(XXX) XXX-XXXX" />
                <small v-if="formIncomplete && !phone?.length" class="form-text err">*Phone Number is required</small>
                <small v-if="!phoneFormat" class="form-text err">*Phone
                  numbers should be formatted with (XXX) XXX-XXX</small>
                <small v-if="phoneTaken" class="form-text err">
                  *Phone number already registered. Click here to <a href="/login" class="underline">
                    Login </a>
                </small>
              </div>

              <div v-if="currentType == 'individual'" class="col-6 mb-3">
                <label class="fs-5 mb-1">Organization</label>

                <input v-model="organization" type="organization" name="organization" class="form-control form-control-lg w-100 fs-5 " placeholder="Attorney Law Firm" />

              </div>
            </div>
            <div class="row g-3 d-flex flex-wrap" v-else>

              <div class="col-12 col-lg-6 pl-0 pr-0 pr-lg-4 mb-3">
                <label class="fs-5 mb-1">Cell Phone Number</label>
                <input v-model="phone" type="phone" name="Phone" class="form-control form-control-lg fs-5 w-100 " placeholder="(XXX) XXX-XXXX" />
                <small v-if="formIncomplete && !phone?.length" class="form-text err">*Phone Number is required</small>
                <small v-if="!phoneFormat" class="form-text err">*Phone
                  numbers should be formatted with (XXX) XXX-XXX</small>
                <small v-if="phoneTaken" class="form-text err">
                  *Phone number already registered. Click here to <a href="/login" class="underline">
                    Login </a>
                </small>
              </div>


              <div v-if="currentType === 'individual'" class="col-12 col-lg-6 px-0 mb-3">
                <label class="fs-5 mb-1">Organization</label>

                <input v-model="organization" type="organization" name="organization" class="form-control form-control-lg w-100 fs-5 " placeholder="Attorney Law Firm" />

              </div>
            </div>

           

            <div class="form-group mb-3">
               <div class="row g-3 d-flex flex-wrap"> 
              <div class="col-12 col-lg-6 pl-0 pr-0 pr-lg-4 mb-3">
                <label class="fs-5 mb-1">County</label>
                <select class="form-control form-control-lg fs-5 w-100" v-model="county" id="">
                  <option :value="null" disabled selected>Select a County</option>
                  <option :value="'N/A'">None/Not Applicable</option>
                  <option class="fs-5" value="Alameda">Alameda</option>
                  <option class="fs-5" value="Alpine">Alpine</option>
                  <option class="fs-5" value="Amador">Amador</option>
                  <option class="fs-5" value="Butte">Butte</option>
                  <option class="fs-5" value="Calaveras">Calaveras</option>
                  <option class="fs-5" value="Colusa">Colusa</option>
                  <option class="fs-5" value="Contra Costa">Contra Costa</option>
                  <option class="fs-5" value="Del Norte">Del Norte</option>
                  <option class="fs-5" value="El Dorado">El Dorado</option>
                  <option class="fs-5" value="Fresno">Fresno</option>
                  <option class="fs-5" value="Glenn">Glenn</option>
                  <option class="fs-5" value="Humboldt">Humboldt</option>
                  <option class="fs-5" value="Imperial">Imperial</option>
                  <option class="fs-5" value="Inyo">Inyo</option>
                  <option class="fs-5" value="Kern">Kern</option>
                  <option class="fs-5" value="Kings">Kings</option>
                  <option class="fs-5" value="Lake">Lake</option>
                  <option class="fs-5" value="Lassen">Lassen</option>
                  <option class="fs-5" value="Los Angeles">Los Angeles</option>
                  <option class="fs-5" value="Madera">Madera</option>
                  <option class="fs-5" value="Marin">Marin</option>
                  <option class="fs-5" value="Mariposa">Mariposa</option>
                  <option class="fs-5" value="Mendocino">Mendocino</option>
                  <option class="fs-5" value="Merced">Merced</option>
                  <option class="fs-5" value="Modoc">Modoc</option>
                  <option class="fs-5" value="Mono">Mono</option>
                  <option class="fs-5" value="Monterey">Monterey</option>
                  <option class="fs-5" value="Napa">Napa</option>
                  <option class="fs-5" value="Nevada">Nevada</option>
                  <option class="fs-5" value="Orange">Orange</option>
                  <option class="fs-5" value="Placer">Placer</option>
                  <option class="fs-5" value="Plumas">Plumas</option>
                  <option class="fs-5" value="Riverside">Riverside</option>
                  <option class="fs-5" value="Sacramento">Sacramento</option>
                  <option class="fs-5" value="San Benito">San Benito</option>
                  <option class="fs-5" value="San Bernardino">San Bernardino</option>
                  <option class="fs-5" value="San Diego">San Diego</option>
                  <option class="fs-5" value="San Francisco">San Francisco</option>
                  <option class="fs-5" value="San Joaquin">San Joaquin</option>
                  <option class="fs-5" value="San Luis Obispo">San Luis Obispo</option>
                  <option class="fs-5" value="San Mateo">San Mateo</option>
                  <option class="fs-5" value="Santa Barbara">Santa Barbara</option>
                  <option class="fs-5" value="Santa Clara">Santa Clara</option>
                  <option class="fs-5" value="Santa Cruz">Santa Cruz</option>
                  <option class="fs-5" value="Shasta">Shasta</option>
                  <option class="fs-5" value="Sierra">Sierra</option>
                  <option class="fs-5" value="Siskiyou">Siskiyou</option>
                  <option class="fs-5" value="Solano">Solano</option>
                  <option class="fs-5" value="Sonoma">Sonoma</option>
                  <option class="fs-5" value="Stanislaus">Stanislaus</option>
                  <option class="fs-5" value="Sutter">Sutter</option>
                  <option class="fs-5" value="Tehama">Tehama</option>
                  <option class="fs-5" value="Trinity">Trinity</option>
                  <option class="fs-5" value="Tulare">Tulare</option>
                  <option class="fs-5" value="Tuolumne">Tuolumne</option>
                  <option class="fs-5" value="Ventura">Ventura</option>
                  <option class="fs-5" value="Yolo">Yolo</option>
                  <option class="fs-5" value="Yuba">Yuba</option>
                </select>
              </div>

              <div class="col-12 col-lg-6 pl-0 pr-0 pr-lg-4 mb-3" v-if="availableAgencies.length > 0">
                <h5 class="fs-5 mb-1">Agency</h5>
                <select class="fs-5 form-control form-control-lg w-100 fs-5" v-model="agency">
                  <option :value="null" disabled selected>Select an Agency</option>
                  <option v-for="agencyOption in filteredAgencies" :value="agencyOption" :key="agencyOption">
                    {{ agencyOption }}
                  </option>
                </select>

                <div v-if="agency == 'Other'" class="w-100 pt-3">
                  <input v-model="otherAgency" type="text" class="form-control form-control-lg w-100 fs-5" placeholder="Enter Agency Name" />
                </div>

                <small v-if="isAgencyRequired && emptyAgency && !emptyOtherAgency" class="form-text err">
                  Agency is required when no county is selected
                </small>

                <small v-if="emptyOtherAgency" class="form-text err">
                  Please enter an agency name
                </small>


              </div></div>

               <div v-if="this.currentType == 'individual'" class="col-12 col-lg-12 px-0">
              <label class="fs-5 mb-1">How did you find us?</label>
              <select v-model="privateReferralSource" type="text" name="howDidYouFindUsPrivate" class="form-control form-control-lg w-100 fs-5">
                <option class="fs-5" :value="null" disabled>Select One</option>
                <option value="search">Word of Mouth</option>
                <option value="referral">Search Engine</option>
                <option value="social_media">Social Media</option>
                <option value="other">Other</option>
              </select>
              <small v-if="emptyPrivateReferralSource && !privateReferralSource" class="form-text err"> Please select your referral source</small>
            </div>

              <div v-if="currentType == 'individual'" class="d-flex flex-column align-items-start">
                <div class="d-flex align-items-center mb-2 mt-3">
                  <input class="mr-2" type="checkbox" id="readTerms" style="cursor: pointer" v-model="readTerms" />
                  <label class="fs-6 mb-0 m-0" style="cursor: pointer" for="readTerms">
                    I have read and agree to the
                    <a href="https://placergroup.com/legalpolicies/termsofservice" class="link" target="_blank">Terms of
                      Service</a>
                  </label>
                </div>
                <small v-if="acceptTOSMessage && !readTerms" class="form-text err mb-2">
                  *Check the box above to agree to the terms of service
                </small>
                <span class="error fs-5 ta-c mt-2" v-if="existingAgency">This agency may already be registered. Please
                  contact us at support@placergroup.com </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body mt-5 ml-5 mr-5 pr-5 pl-5" v-else>
          <!-- Enterprise options -->
          <div v-if="currentType === 'enterprise'" class="form-group mb-3">
            <label class="fs-5 mb-1">Who are you within your organization?</label>

            <select v-model="roleWithinOrg" type="organization" name="organization" class="form-control form-control-lg w-100 fs-5">
              <option value="" disabled>Select an option</option>
              <option value="admin">Manager/Supervisor</option>
              <option value="manager">IT Staff</option>
              <option value="employee">Employee</option>
              <option value="other">Other</option>
            </select>

            <input v-if="roleWithinOrg === 'other'" v-model="otherRoleWithinOrg" type="text" name="otherOrganization" class="form-control form-control-lg w-100 mt-3 fs-5" placeholder="Enter your role" />
            <small v-if="emptyRoleWithinOrg && !effectiveRole" class="form-text err">Please fill in your role</small>
          </div>

          <div v-if="currentType === 'enterprise'" class="row g-3 mb-3">
            <div class="col-12 col-lg-6 pl-0">
              <label class="fs-5 mb-1">Estimated # of users?</label>

              <select v-model="estimatedUsers" type="number" name="estimatedUsers" class="form-control form-control-lg w-100 fs-5">
                <option value="" disabled>Select an option</option>
                <option value="1-10">1-10</option>
                <option value="11-20">11-20</option>
                <option value="21-30">21-30</option>
                <option value="31-40">31-40</option>
                <option value="41-50">41-50</option>
                <option value="50+">50+</option>

              </select>
              <small v-if="emptyEstimatedUsers && !estimatedUsers" class="form-text err"> Please select your estimated users</small>
            </div>
            <div class="col-12 col-lg-6 pr-0">
              <label class="fs-5 mb-1">How did you find us?</label>

              <select v-model="referralSource" type="text" name="howDidYouFindUs" class="form-control form-control-lg w-100 fs-5">
                <option value="" disabled>Select an option</option>
                <option value="search">Word of Mouth</option>
                <option value="referral">Search Engine</option>
                <option value="social_media">Social Media</option>
                <option value="other">Other</option>
              </select>
              <small v-if="emptyReferralSource && !referralSource" class="form-text err"> Please select your referral source</small>
            </div>

          </div>

          <div v-if="currentType === 'enterprise'" class="form-group mb-3">
            <label class="fs-5 mb-1">Anything else we should know?</label>
            <textarea v-model="additionalComments" name="organization" class="form-control form-control-lg w-100 fs-5" placeholder="Let us know any additional information or questions you have here."></textarea>
          </div>

          <div class="d-flex flex-column align-items-start">
            <div class="d-flex align-items-center mb-3">
              <input class="mr-2" type="checkbox" id="readTerms" style="cursor: pointer" v-model="readTerms" />
              <label class="fs-6 mb-0 m-0" style="cursor: pointer" for="readTerms">
                I have read and agree to the
                <a href="https://placergroup.com/legalpolicies/termsofservice" class="link" target="_blank">Terms of
                  Service</a>
              </label>
            </div>
            <small v-if="acceptTOSMessage && !readTerms" class="form-text err mb-2">
              *Check the box above to agree to the terms of service
            </small>
            <!-- <p v-if="currentType === 'individual'" class="ml-1"> Need an Enterprise Plan? <a href="https://placergroup.com/crimetime/pricing" target="_blank" class="click-here-link">Click here</a> to learn more.</p> -->


          </div>


        </div>
        <div class="d-flex justify-content-center">
          <span v-if="existingAgency && this.currentType == 'enterprise'" class="error fs-5 ta-c">This agency may already be registered. <br> </br>Please
            contact us at support@placergroup.com
          </span>
        </div>
        <p class="form-text fs-5" style="text-align: center; color: red;" v-if="validationError">{{ validationError }}
        </p>
        <div v-if="currentType === 'individual' || enterpriseSignupQuestionModal == true" class="d-flex justify-content-between ml-5 mr-5 pr-5 pl-5 pb-5 pt-0">
          <button class="btn btn-primary btn-xl" v-if="!loading && !existingAgency" @click="signUp()">
            Submit
          </button>
          <LoadingButton style="height: 40px" v-else-if="loading" />
          <div v-else></div>
          <a href="https://placergroup.com/contact" target="_blank">
            <button class="btn btn-primary-outline btn-xl">Need Help?</button>
          </a>

        </div>
        <div v-else class="d-flex justify-content-between ml-5 mr-5 pr-5 pl-5 pb-5 pt-0">
          <button class="btn btn-primary btn-xl" v-if="!loading && !existingAgency" @click="checkEnterpriseFields();">
            Continue
          </button>
          <LoadingButton style="height: 40px" v-else-if="loading" />
          <div v-else></div>
          <a href="https://placergroup.com/contact" target="_blank">
            <button class="btn btn-primary-outline btn-xl">Need Help?</button>
          </a>

        </div>

        <p class="form-text fs-5" style="text-align: center; color: red;" v-if="validationError">{{ validationError }}
        </p>

      </div>
      <div class="d-flex justify-content-end">
        <p v-if="currentType === 'individual'" class="mt-1 fs-5"> Need an Enterprise Plan? <a href="https://placergroup.com/crimetime/pricing" target="_blank" class="click-here-link">Click here</a> to learn more.</p>
      </div>

    </div>

    <!-- Modal for Phone Verification -->
    <div v-if="verificationSMSModal" class="d-flex justify-content-center align-items-center col-12 col-lg-6 " style="padding-bottom: 150px;">
      <div class="card border-radius-1 border w-100 w-md-75 w-lg-50 my-4 ">


        <div class="d-flex modal-header justify-content-center fw-bold fs-3 pl-5 ">
          Phone Verification
        </div>
        <div class="card-body p-5 ">

          <div class="d-flex flex-column align-items-center">
            <h5 class=" mb-3 fs-4">We sent you a One Time Passcode to:</h5>
            <h5 class=" mb-3 fw-bold fs-4"> {{ this.phone }} </h5>
            <h5 class=" mb-3 fs-4">Enter the 6-digit authorization code</h5>
            <div class=" mb-2">
              <div class="d-flex">
                <input v-model="OneTimeCode" type="text" class="form-control form-control-lg" style="width: 250px;" />
              </div>
              <small v-if="userEnteredVerifyCodeWrong" class="form-text err">*Incorrect code.
                Try again</small>
              <small v-else-if="userEnteredTooShortVerifyCode" class="form-text err">*Code is
                six digits. Try again</small>
              <small v-else-if="invalidParameterCode" class="form-text err">*Incorrect code. Try
                again </small>
              <small v-else-if="maxCheckAttemptsReached" class="form-text err">*Max attempts
                reached. Try again in 10 minutes.</small>
              <small v-else-if="tokenExpired" class="form-text err">*Enter code texted to your
                phone number*</small>
              <small v-else-if="userAlreadyCreated" class="form-text err">
                *User already created. Please
                <span style="color: #007bff; text-decoration: underline; cursor: pointer;" @click="$router.push('/login')">log in</span>.
              </small>
              <div v-else-if="validationError" class="form-text err">{{ validationError }}</div>
              <div v-else-if="resendMessage" class="form-text" style=" color: red;">{{ resendMessage }}</div>
            </div>

            <div class="d-flex d-flex py-2">
              <loading-button v-if="loading == true" />
              <button v-else @click="filterNonNumericOTPCode(OneTimeCode); verifyCode();" class="btn btn-primary btn-xl mx-2">Verify</button>
              <button class="btn btn-secondary btn-xl mx-2" :disabled="resendCooldown" @click="resendCode">Resend
                Code</button>
              <!-- <button class="btn btn-primary btn-xl" @click="setVerificationSMSModalToFalse">Back</button> -->
            </div>
            <span class="text-muted d-flex mt-3" style="font-size: 0.8rem"> If you haven't received a code in 60
              seconds, click Resend Code</span>

          </div>
          <!-- <div class="d-flex justify-content-center"> -->
          <!-- <button class="btn btn-primary btn-xl" @click="setVerificationSMSModalToFalse">Back</button> -->
          <!-- </div> -->
        </div>
      </div>
    </div>

  </main> 
</template>

<script>
import moment from 'moment'
import axios from "axios";
import Modal from "../../components/utils/Modal.vue";
import PostLoginHeader from "./PostLoginHeader.vue";
import LoadingButton from "../../components/utils/LoadingButton.vue";
import OAuth from "./OAuth.vue";
// Shown when signup fails before an account exists. The texted code is single-use, so the
// user must start over (refresh) rather than press Verify again.
const RESTART_SIGNUP_MESSAGE = "We couldn't create your account. Please refresh the page and sign up again.";

export default {
  components: { Modal, PostLoginHeader, LoadingButton, OAuth },
  name: "GetStarted",
  data() {
    return {
      username: "",
      password: "",
      passwordConfirm: "",
      firstName: "",
      lastName: "",
      phone: "",
      OneTimeCode: "",
      filteredOTPCode: "",
      emailTaken: false,
      phoneTaken: false,
      passwordMatch: true,
      phoneFormat: true,
      emailFormat: true,
      validUser: false,
      // isCounty: false,
      county: null,
      agency: null,
      formIncomplete: false,
      acceptTOSMessage: false,
      loading: false,
      linkMicrosoftAccount: false,
      microsoftAccountInfo: null,
      useMicrosoftAccount: false,
      phoneNumberVerifiedThroughTwilio: false,
      userEnteredVerifyCodeWrong: false,
      userEnteredTooShortVerifyCode: false,
      isModalOpen: false,
      maxCheckAttemptsReached: false,
      invalidParameterCode: false,
      tokenExpired: false,
      validationError: null,
      weakPassword: false,
      onboarding: false,
      organization: "",

      verificationSMSModal: false,
      resendMessage: null,
      resendCooldown: false,
      resendAttempts: 0,
      resendCooldownTime: 60, 
      maxResendAttempts: 5,
      organizationSettings: {},
      availableAgencies: [
        'None/Not Applicable',
        'Alternate Public Defender',
        'Court',
        'District Attorney',
        'Law Enforcement',
        'Probation',
        'Public Defender',
        'Other'
      ],
      takenAgencies: [],
      otherAgency: '',
      readTerms: false,
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      //Enterprise options
      enterpriseSignupQuestionModal: false,
      roleWithinOrg: null,
      otherRoleWithinOrg: null,
      estimatedUsers: null,
      referralSource: null,
      additionalComments: null,
      //error handling
      emptyRoleWithinOrg: false,
      emptyEstimatedUsers: false,
      emptyReferralSource: false,

      emptyPrivateReferralSource: false,
      privateReferralSource: null,
      userAlreadyCreated: false,
      emptyAgency: false,
      emptyOtherAgency: false,
      // emptyAdditionalComments: false,


    };
  },

  watch: {
    password: 'evaluatePasswordStrength',
    passwordConfirm: "comparePasswords",
    phone: "formatPhone",
    county: "loadAgencies",
    
  },
  mounted() {
    // console.log('currentType', this.currentType);

    const savedFormData = JSON.parse(localStorage.getItem('signUpFormData'));
    if (savedFormData) {
      this.username = savedFormData.username;
      // this.password = savedFormData.password;
      // this.passwordConfirm = savedFormData.passwordConfirm;
      this.firstName = savedFormData.firstName;
      this.lastName = savedFormData.lastName;
      // this.phone = savedFormData.phone;
      this.organization = savedFormData.organization;
      this.currentType = savedFormData.type; 
      // this.isCounty = savedFormData.isCounty;
      this.county = savedFormData.county;
      this.agency = savedFormData.agency;
    }
  },

  computed: {
    //remove None/not applicable option from enterprise signup
    filteredAgencies() {
      if (this.currentType === 'individual') {
        return this.availableAgencies;
      }
      return this.availableAgencies.filter(a => a !== 'None/Not Applicable');
    },

    // if no county selected, agency is required
    isAgencyRequired() {
      return !this.county || this.county === 'N/A';
    },

    effectiveRole() {
      return this.roleWithinOrg === 'other'
        ? this.otherRoleWithinOrg
        : this.roleWithinOrg;
    },


    currentType() {
      // Access the dynamic segment from the current route
      return this.$route.params.type;
    },

    existingAgency() {
      if (this.agency) {
        if (this.agency == 'District Attorney') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('district attorney') || str.toLowerCase()?.includes('district attorney office') || str.toLowerCase()?.includes('da');
          })
          if (foundIndex != -1) {
            return true
          }
        } else if (this.agency == 'Probation') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('probation department') || str.toLowerCase()?.includes('probation office') || str.toLowerCase()?.includes('probation');
          })
          if (foundIndex != -1) {
            return true
          }
        } else if (this.agency == 'Law Enforcement') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('law enforcement') || str.toLowerCase()?.includes('law enforcement agency') || str.toLowerCase()?.includes('police department');
          })
          if (foundIndex != -1) {
            return true
          }
        } else if (this.agency == 'Court') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('court') || str.toLowerCase()?.includes('superior court');
          })
          if (foundIndex != -1) {
            return true
          }
        } else if (this.agency == 'Public Defender') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('public defender') || str.toLowerCase()?.includes('public defender office') || str.toLowerCase()?.includes('pd');
          })
          if (foundIndex != -1) {
            return true
          }
        } else if (this.agency == 'Alternate Public Defender') {
          const foundIndex = this.takenAgencies.findIndex(str => {
            return str.toLowerCase()?.includes('alternate public defender')
          })
          if (foundIndex != -1) {
            return true
          }
        }
      }
      return false
    },
    // buttonText() {
    //   const savedFormData = localStorage.getItem('signUpFormData');
    //   return savedFormData ? 'Submit' : 'Start Trial';
    // }
  },

  methods: {

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    toggleConfirmPasswordVisibility() {
      this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
    },

    async checkEnterpriseFields(){
      
      this.validationError = null;
      this.emailTaken = false;
      this.phoneTaken = false;
      this.passwordMatch = true;
      this.phoneFormat = true;
      this.emailFormat = true;
      this.weakPassword = false;
      this.formIncomplete = false;
      this.acceptTOSMessage = false;
      this.userAlreadyCreated = false;

      if (!this.username?.length || !this.password?.length ||
        !this.phone?.length || !this.firstName?.length || !this.lastName?.length) {
          // console.log('Incomplete fields');
        this.formIncomplete = true;
        return;
      }

      // if (this.password !== this.passwordConfirm) {
      //   this.passwordMatch = false;
      //   return;
      // }

      if (!this.phoneFormat) {
        // console.log('Phone format invalid');
        this.phoneFormat = false;
        return;
      }

      if (this.weakPassword) {
        // console.log('Weak password');
        this.weakPassword = true;
        return;
      }

      try {
        const foundEmail = await axios.post(process.env.VUE_APP_ENDPOINT + `/api/registration/checkEmail`, {
          UserName: this.username,
        });

        if (foundEmail.data?.emailTaken) {
          this.emailTaken = true;
          this.loading = false;
          return;
        }
      } catch (error) {
        console.error('Error checking email:', error);
        // Assume email is taken if there's an error
        this.emailTaken = true;
        this.loading = false;
        return;
      }
      // Phone Number check in DB
      try {
        // console.log('Checking phone number uniqueness');
        const canProceed = await this.checkPhoneNumberUniqueness();
        if (!canProceed) {
          this.phoneTaken = true;
          return;
        }
      } catch (error) {
        console.error('Error checking phone number:', error);
        this.phoneTaken = true;
        return;
      }
      //make sure agency isn't empty
       if (this.isAgencyRequired && !this.agency) {
        this.emptyAgency = true;
        return;
      }
      //if other selected on agency, make sure its filled out
        if (this.agency === 'Other' && !this.otherAgency.trim()) {
      this.emptyOtherAgency = true;
        return;
      }
    
      // Proceed with registration
      this.enterpriseSignupQuestionModal = true; 

    },

    async signUp() {
      
      this.validationError = null;
      this.emailTaken = false;
      this.phoneTaken = false;
      this.passwordMatch = true;
      this.phoneFormat = true;
      this.emailFormat = true;
      this.weakPassword = false;
      this.formIncomplete = false;
      this.acceptTOSMessage = false;
      this.emptyReferralSource = false;
      this.emptyEstimatedUsers = false;
      this.emptyPrivateReferralSource = false;
      // this.privateReferralSource = null;
      this.emptyRoleWithinOrg = false;
      this.userAlreadyCreated = false;
      this.emptyAgency = false;
      this.emptyOtherAgency = false;

      if (!this.username?.length || !this.password?.length ||
        !this.phone?.length || !this.firstName?.length || !this.lastName?.length) {
        this.formIncomplete = true;
        return;
      }

      // if (this.password !== this.passwordConfirm) {
      //   this.passwordMatch = false;
      //   return;
      // }

      if (!this.phoneFormat) {
        this.phoneFormat = false;
        return;
      }

      if (this.weakPassword) {
        this.weakPassword = true;
        return;
      }

      if (!this.privateReferralSource && this.currentType == 'individual') {
        this.emptyPrivateReferralSource = true;
        return;
      }

      if (this.currentType === 'enterprise') {
        // If user selected "Other", replace value
        if (this.roleWithinOrg === 'other') {
          this.roleWithinOrg = this.otherRoleWithinOrg;
        }

        //checking if the role is other, and making sure they enter their organization role
        const effectiveRole = this.effectiveRole;

        if (!effectiveRole || !this.estimatedUsers || !this.referralSource) {
          this.emptyRoleWithinOrg = !effectiveRole;
          this.emptyEstimatedUsers = !this.estimatedUsers;
          this.emptyReferralSource = !this.referralSource;
          return;
        }
      }

      try {
        const foundEmail = await axios.post(process.env.VUE_APP_ENDPOINT + `/api/registration/checkEmail`, {
          UserName: this.username,
        });

        if (foundEmail.data?.emailTaken) {
          this.emailTaken = true;
          this.loading = false;
          return;
        }
      } catch (error) {
        console.error('Error checking email:', error);
        // Assume email is taken if there's an error
        this.emailTaken = true;
        this.loading = false;
        return;
      }

      // if (this.organizationSettings?.EnforceMicrosoftSignOn)

      // Phone Number check in DB
      try {
        // console.log('Checking phone number uniqueness');
        const canProceed = await this.checkPhoneNumberUniqueness();
        if (!canProceed) {
          this.phoneTaken = true;
          return;
        }
      } catch (error) {
        console.error('Error checking phone number:', error);
        this.phoneTaken = true;
        return;
      }

       if (!this.readTerms) {
        this.acceptTOSMessage = true;
        return;
      }

      // Proceed with phone verification w/ Twilio
      try {
        const good = await this.sendVerificationSMS();
        if (good) {
          this.verificationSMSModal = true;
          // Save form data to local storage
          const formData = {
            username: this.username,
            firstName: this.firstName,
            lastName: this.lastName,
            organization: this.organization,
            county: this.county,
            agency: this.agency
          };
          localStorage.setItem('signUpFormData', JSON.stringify(formData));
        } else {
          // this.validationError = 'There was an issue verifying your phone number. Please try again later.';
          this.verificationSMSModal = false;
        }
      } catch (error) {
        console.error('Error during registration:', error);
        this.validationError = "Error during registration";
      } finally {
        this.loading = false;
      }

    },

    async checkPhoneNumberUniqueness() {
      if (!this.phone) {
        return false;
      }

      this.loading = true;

      try {
        const response = await axios.post(`${process.env.VUE_APP_ENDPOINT}/api/registration/checkPhoneNumber`, {
          PhoneNumber: this.phone,
        }).then(data => {
          return data?.data?.uniquePhoneNumber;
        })

        return response;

      } catch (error) {
        console.error('Error checking phone number:', error);
        return false;
      } finally {
        this.loading = false;
      }
    },


    async sendVerificationSMS() {
      try {
        const smsResponse = await axios.post(process.env.VUE_APP_ENDPOINT + '/api/registration/sendVerificationSMS', {
          phoneNumber: this.phone, 
        });
        this.verificationSMSModal = true;
        return true;
      } catch (err) {
        this.loading = false;
        if (err.response) {
          console.error('Error response:', {
            status: err.response.status,
            data: err.response.data,
            headers: err.response.headers,
          });
          if (err.response.data.error.includes('Max send attempts reached')) {
            this.validationError = 'Max send attempts reached. Please wait and try again later.';
          } else {
            this.validationError = `There was an issue verifying your phone number. Please wait and try again later.`;
          }
        } else if (err.request) {
          console.error('Error request:', err.request);
          this.validationError = 'No response received from the server. Please try again later.';
        } else {
          console.error('Error setting up request:', err.message);
          this.validationError = `There was an issue verifying your phone number. Error: ${err.message}`;
        }
        return false;
      }
    },

    async resendCode() {
      if (this.resendCooldown) {
        this.resendMessage = `Please wait ${this.resendCooldownTime} seconds before trying again.`;
        return;
      }

      if (this.resendAttempts >= this.maxResendAttempts) {
        this.resendMessage = 'You have reached the maximum number of resend attempts. Please try again later.';
        return;
      }

      // Reset validation and error states
      this.validationError = null;
      this.tokenExpired = false;
      this.maxCheckAttemptsReached = false;
      this.invalidParameterCode = false;
      this.userEnteredTooShortVerifyCode = false;
      this.userEnteredVerifyCodeWrong = false;
      this.resendMessage = null;

      try {
        // console.log('Resending verification code...');
        const success = await this.sendVerificationSMS();
        if (success) {
          this.resendMessage = 'A new verification code has been sent to your phone.';
          this.resendAttempts++;
          this.startCooldown();
        } else {
          this.resendMessage = 'There was an issue resending the verification code. Please try again later.';
        }
      } catch (err) {
        if (err.response) {
          console.error('Error response:', {
            status: err.response.status,
            data: err.response.data,
            headers: err.response.headers,
          });
          this.resendMessage = `There was an issue resending the verification code. Error: ${err.response.data.message || err.message}`;
        } else if (err.request) {
          console.error('Error request:', err.request);
          this.resendMessage = 'No response received from the server. Please try again later.';
        } else {
          console.error('Error setting up request:', err.message);
          this.resendMessage = `There was an issue resending the verification code. Error: ${err.message}`;
        }
      }
    },

    // Reset code cooldown is 60 seconds
    startCooldown() {
      this.resendCooldown = true;
      setTimeout(() => {
      this.resendCooldown = false;
      }, this.resendCooldownTime * 1000);
    },


    async verifyCode() {

      this.loading = true;
      this.userEnteredVerifyCodeWrong = false;
      this.userEnteredTooShortVerifyCode = false;
      this.maxCheckAttemptsReached = false;
      this.invalidParameterCode = false;
      this.tokenExpired = false;

      try {
        const verificationResponse = await axios.post(process.env.VUE_APP_ENDPOINT + '/api/registration/verifyCode', {
          phoneNumber: this.phone,
          code: this.OneTimeCode,
        });

        if (verificationResponse.status === 200) {
          this.phoneNumberVerifiedThroughTwilio = true;
          // this.loading = false;
          this.createUser();
          return;
        }
      } catch (error) {
        if (error.response) {
          const errorMessage = error.response.data.message || '';
          if (error.response.status === 400) {
            if (errorMessage.includes("Phone number and verification code are required.")) {
              this.tokenExpired = true;
              this.loading = false;
            } else {
              this.userEnteredVerifyCodeWrong = true;
              this.loading = false;
            }
          } else if (error.response.status === 500) {
            if (errorMessage.includes("Max check attempts reached")) {
              this.maxCheckAttemptsReached = true;
            } else if (errorMessage.includes("Failed to verify OTP")) {
              this.invalidParameterCode = true;
            } else {
              console.error('An internal server error occurred. Please try again later.');
            }
          } else if (error.response.status === 429) {
            this.maxCheckAttemptsReached = true;
          } else {
            console.error('An unexpected error occurred. Please try again later.');
          }
        } else if (error.request) {
          console.error('No response received from the server.');
        } else {
          console.error('Error setting up the request:', error.message);
        }
      } finally {
        // this.loading = false;
      }
    },

    async createUser() {
      if (!this.phoneNumberVerifiedThroughTwilio) {
        return;
      }

      const userObject = {
        UserName: this.username,
        NormalizedUserName: this.username.toUpperCase(),
        Email: this.username,
        NormalizedEmail: this.username.toUpperCase(),
        SecurityStamp: "",
        ConcurrencyStamp: "",
        TwoFactorEnabled: true,
        LockoutEnabled: false,
        AccessFailedCount: "0",
        FirstName: this.firstName,
        LastName: this.lastName,
        PhoneNumber: this.phone,
        PhoneNumberConfirmed: false,
        CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        EmailConfirmed: true,
        HashedPassword: this.password,
        isAdmin: 1,
        firstLoginMessage: false,
        AdPopUpId: null,
      };

      let organizationSettingsId = null;
      // Once the user is linked to their subscriber the account is complete; later failures
      // (login, Microsoft link) must not tell the user to sign up again.
      let accountCreated = false;

      if (this.currentType == "enterprise") {
        userObject.WhichCounty = this.county;
        userObject.WhichAgency = this.agency;
        if (this.agency == 'Other') {
          userObject.WhichAgency = this.otherAgency;
        }

        // Outside the try below, so catch here: an unhandled rejection would leave the spinner running.
        const createdOrganizationSettings = await axios.post(
          process.env.VUE_APP_ENDPOINT + `/api/OrganizationSettings`,
          {
            DefendantFirstName: true,
            DefendantMiddleName: true,
            DefendantLastName: true,
            DefendantDOB: true,
            EnforceMicrosoftSignOn: false,
            SessionLifespanUnits: 'weeks',
            SessionLifespanLength: 2,
          }
        ).catch((error) => {
          console.error('Error creating organization settings:', error);
          return null;
        });
        if (!createdOrganizationSettings?.data?.Id) {
          this.loading = false;
          this.validationError = RESTART_SIGNUP_MESSAGE;
          return;
        }

        organizationSettingsId = createdOrganizationSettings.data?.Id;
      }else{
        //send email only if private/individual user
         userObject.SendEmailToNewUser = true;
      }
   


      try {
        const createdUser = await axios.post(process.env.VUE_APP_ENDPOINT + `/api/JWTUser`, userObject);
        // console.log('CREATED USER: ', createdUser)
        // The server answers 200 with an empty body if the insert failed: no account exists yet,
        // so starting over works (the texted code is already used, so Verify can't be retried).
        if (!createdUser?.data?.id) {
          this.loading = false;
          this.validationError = RESTART_SIGNUP_MESSAGE;
          return;
        }
        // The server sets seats, status, dates, email and name itself (see newSubscriberGuard).
        const subscriberObj = {
          Organization: this.organization,
          SubscriptionType: this.currentType == "enterprise" ? 3 : 2,
          JWTUserId: createdUser.data?.id,
          // Proves to the server that this signup created that user
          JWTUserGuid: createdUser.data?.guid,
          OrganizationSettingsId: organizationSettingsId,
        };
        //grabs user's referral source based on currentType
        if (this.currentType == "enterprise") {
          subscriberObj.enterpriseOptions = {
            roleWithinOrg: this.effectiveRole,
            estimatedUsers: this.estimatedUsers,
            referralSource: this.referralSource,
            additionalComments: this.additionalComments
          };
        } else if (this.currentType == "individual") {
          subscriberObj.privateOptions = {
            referralSource: this.privateReferralSource
          }
        }
        // (A 409 "user already exists" rejects the POST above; the outer catch handles it.)
        let subscriberError = null;
        const createdSubscriber = await axios.post(process.env.VUE_APP_ENDPOINT + `/api/subscriber`, subscriberObj).catch((error) => {
          console.error('Error creating subscriber:', error);
          subscriberError = error;
        });
        // Stop here: linking a user to a subscriber that wasn't created leaves a stuck account.
        if (subscriberError || !createdSubscriber?.data?.Id) {
          this.loading = false;
          // Retrying can't help (the user already exists), so point them at support.
          this.validationError = "We couldn't finish setting up your account. Please contact support@placergroup.com and we'll complete it for you.";
          return;
        }

        // Timeout: this route's 403 path never responds. Without the link the user has no subscription.
        const linkedUser = await axios.patch(process.env.VUE_APP_ENDPOINT + `/api/JWTUsers/AddSubscriberToUser`, {
          id: subscriberObj?.JWTUserId,
          SubscriberId: createdSubscriber.data?.Id,
        }, { timeout: 30000 }).catch((error) => {
          console.error('Error linking user to subscriber:', error);
          return null;
        });
        if (linkedUser?.status !== 200) {
          this.loading = false;
          this.validationError = "We couldn't finish setting up your account. Please contact support@placergroup.com and we'll complete it for you.";
          return;
        }
        accountCreated = true;


        if (this.currentType == "enterprise") {
          await axios.post(
            process.env.VUE_APP_ENDPOINT + `/api/EnterpriseSignups`,
            {
              FirstName: this.firstName,
              LastName: this.lastName,
              UserName: this.username,
              County: this.county,
              Agency: this.agency,
              RoleWithinOrg: this.effectiveRole,
              EstimatedUserCount: this.estimatedUsers,
              ReferralSource: this.referralSource,
              AdditionalComments: this.additionalComments,
              // 0 means Enterprise signup
              SignUpType: 0,
              SubscriberId: createdSubscriber.data?.Id,
              CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
          ).catch((error) => {
            console.error('Error creating enterprise signup:', error);
          });
        } else {

          await axios.post(
            process.env.VUE_APP_ENDPOINT + `/api/EnterpriseSignups`,
            {
              FirstName: this.firstName,
              LastName: this.lastName,
              UserName: this.username,
              County: this.county,
              Agency: this.agency,
              ReferralSource: this.privateReferralSource,
              // 1 means Private signup
              SignUpType: 1,
              SubscriberId: createdSubscriber.data?.Id,
              CreatedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
          ).catch((error) => {
            console.error('Error creating enterprise signup:', error);
          });

        }

        const bodyObj = {
          username: this.username,
          password: this.password,
        };

        const signIn = await axios.post(process.env.VUE_APP_ENDPOINT + "/api/auth/login", bodyObj, {
          headers: { "Content-Type": "application/json" },
        });

        if (signIn.data?.authorized == true) {
          localStorage.setItem("user_token", signIn.data?.token);
          localStorage.setItem("user_key", signIn.data?.key);
          localStorage.setItem("user_attr", JSON.stringify(signIn.data?.user_attr));
          localStorage.removeItem('signUpFormData');

          if (this.useMicrosoftAccount) {
            const msUserObject = {
              MicrosoftEmail: this.microsoftAccountInfo?.username,
              MicrosoftId: this.microsoftAccountInfo?.localAccountId,
              MicrosoftOrganizationId: null,
              MicrosoftOrganizationAdmin: false,
              EmailAuthenticated: false,
            };

            const brr = this.microsoftAccountInfo?.name?.split(" ");
            msUserObject.LastName = brr[brr?.length - 1];
            brr.pop();
            msUserObject.FirstName = this.microsoftAccountInfo?.given_name || brr.join(" ");

            await axios.post(process.env.VUE_APP_ENDPOINT + `/api/microsoftusers`, msUserObject, {
              headers: {
                Authorization: `Bearer ${signIn.data?.token}`,
              },
            });
          }

          localStorage.setItem("subscription_status", signIn.data?.subscriptionStatus);
          
          if (this.currentType == "enterprise") {
            this.loading = false;
           this.$router.push("/Cases");
          } else {
            this.loading = false;
           this.$router.push("/createSubscription");
          }
        } else {
          this.loading = false;
          this.errMessage = "Invalid Login";
        }
      } catch (error) {
        console.error('Error in createUser:', error);
        this.loading = false;
        this.errorMessage = error?.response?.data?.message || error.message;
        // errorMessage isn't shown in the template; surface the cases the modal can display.
        if (accountCreated) {
          this.validationError = "Your account was created, but we couldn't finish signing you in. Please log in.";
        } else if (error?.response?.status === 409) {
          this.userAlreadyCreated = true;
        } else {
          this.validationError = RESTART_SIGNUP_MESSAGE;
        }
      }
    },

    evaluatePasswordStrength() {
      if (
        this.password.length < 8 ||
        this.password.length > 20 ||
        !this.password.match(/[a-z]/) ||
        !this.password.match(/[A-Z]/) ||
        !this.password.match(/[0-9]/) ||
        !this.password.match(/[^a-zA-Z\d]/)
      ) {
        this.weakPassword = true;
      } else {
        this.weakPassword = false;
      }
    },

    async loadAgencies() {
      if(!this.county){
        return;
      }
      const agencies = await axios.post(process.env.VUE_APP_ENDPOINT + "/api/registration/checkCountyStatus", {
        county: this.county,
      }).then((response) => {
        return response.data;
      }).catch(error => {
        console.error(error);
      });
      this.takenAgencies = agencies.agencies.filter(agency => agency)
    },

    comparePasswords() {
      this.password == this.passwordConfirm
        ? (this.passwordMatch = true)
        : (this.passwordMatch = false);
    },
    filterNonNumericOTPCode(userPhoneNumber) {
      this.filteredOTPCode = userPhoneNumber.replace(/\D/g, "");
    },

    checkEmailFormat() {
      const emailRegex = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (emailRegex.test(this.username)) {
        this.emailFormat = true;
      } else {
        this.emailFormat = false;
      }
    },

    formatPhone() {
      const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (phoneRegex.test(this.phone)) {
        this.phone = this.phone.replace(phoneRegex, "($1) $2-$3");
      }
    },

    handleOAuth(event) {
      // console.log(event);
      if (event?.username?.length > 0) {
        const nameArr = event?.name?.split(" ");
        this.lastName = nameArr[nameArr?.length - 1];
        nameArr.pop();
        this.firstName = nameArr.join(" ");
        this.username = event?.username;
        this.microsoftAccountInfo = event;
        this.useMicrosoftAccount = true;
      }
    },
  },
};
</script>

<style scoped>

.error {
  font-style: italic;
  font-weight: bold;
  font-size: 0.75rem;
  color: red;
}

.err{
  font-style: italic;
  font-weight: bold;
  font-size: 0.75rem;
  color: red;
}

.blue-circle {
    width: 25vw;
    height: 25vw;
    border-radius: 50%;
    background-color: var(--button);
    display: block
}

#hero-img {
  top: 70px;
  left:  -20px;
    /* margin-left: 30px; */
  max-width: 100%; 
  height: auto; 
  position: relative;
  display: block; 
}

@media (max-width: 767px) {
  #hero-img {
    top: 0;
  }
  .blue-circle {
    width: 60vw;
    height: 60vw;
  }
}

.account-card {
  width: 40rem;
  /* min-height: 40rem;  */
}

.hero-container {
  min-height: 100vh;
}


.split-right {
  overflow-y: auto;
  height: 100%; 
  display: flex; 
  flex-direction: column; 
  align-items: center;
  justify-content: center;
}

.split-left {
  background: linear-gradient(to bottom, #e6f4ff 0%, #e6f4ff 50%, var(--button) 50%, var(--button) 100%);  
  display: flex;
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  text-align: center; 
}

/* Consider responsiveness for smaller screens */
@media (max-width: 767.98px) {
  .account-card {
    width: 90%; 
    max-width: 25rem; 
    min-height: auto; 
    height: auto;
  }
}

@media (max-width: 575.98px) { /* For extra small devices */
  .account-card {
    width: 95%; 
    padding: 1.5rem;
  }
}

.password-input-wrapper {
  position: relative; 
  width: 100%; 
}

.password-toggle-icon {
  position: absolute; 
  right: 15px; 
  top: 50%;
  transform: translateY(-50%); 
  cursor: pointer; 
  color: #6c757d; 
  z-index: 2; 
  font-size: 1.25rem; 
}


.text-top,
.text-bottom {
  width: 100%; 
}

.text-muted {
  color: #6c757d !important;
}

.form-group {
  display: block;
  justify-content: center;
}

small {
  display: block;
  color: red;
}

.link {
  color: var(--button) !important;
}
.link:hover {
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

.click-here-link{
  cursor: pointer;
  color: var(--button) !important;
}
.click-here-link:hover {
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

</style>
